var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.layoutType === 'vertical')?_c('vertical',{attrs:{"layout":_vm.layoutType}},[_vm._t("default")],2):_vm._e()],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }